export const formatParsePercent = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    style: "unit",
    unit: "percent",
    useGrouping: true,
    minimumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}

export const formatParseInt = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    // useGrouping: true,
    minimumFractionDigits: precision,
    // maximumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}

export const formatParseFloat = (val: string | any, precision: number) => {
  const dollarUSLocale = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    useGrouping: true,
    minimumFractionDigits: precision,
    // maximumFractionDigits: precision,
  })

  return dollarUSLocale.format(parseFloat(val || "0"))
}

export const formatRoundUp = (val: string | any, type: string | any) => {
  if (type == "#") {
    return val
  } else if (type == "$") {
    return val
  } else if (type == "%") {
    return parseFloat(val || "0")
  } else {
    return val
  }
}

export const roundUp = (value: string, type: string, precision?: any) => {
  return type === "%"
    ? formatParsePercent(value, precision)
    : type === "#"
    ? formatParseInt(value, precision)
    : type === "$"
    ? formatParseFloat(value, precision)
    : value
}

export const formatNumber = (val: string | any, formatType: string) => {
  // Handle null, undefined, empty string, or NaN values
  if (val === null || val === undefined || val === "" || isNaN(val)) {
    return ""
  }

  const params =
    formatType === "$"
      ? { style: "currency", currency: "USD" }
      : formatType === "%"
      ? { style: "unit", unit: "percent" }
      : {}

  // Set decimal places based on format type
  const decimalOptions =
    formatType === "$"
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : formatType === "%"
      ? { minimumFractionDigits: 1, maximumFractionDigits: 2 }
      : {}

  const formatHandler = Intl.NumberFormat("en-US", {
    ...params,
    useGrouping: true,
    ...decimalOptions,
  })

  const numericValue = parseFloat(val)
  // Double-check for NaN after parsing
  if (isNaN(numericValue)) {
    return ""
  }

  return formatHandler.format(numericValue)
}

export const convertToInternationalNumberSystem = (
  numberString: string,
  datatype?: "$" | "#" | "%",
): string => {
  // Split the input into integer and decimal parts
  const [integerPart, decimalPart] = numberString?.split(".")

  // Use a regular expression to insert commas every three digits
  const formattedIntegerPart = integerPart?.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ",",
  )

  // Combine the formatted integer part with the decimal part (if it exists)
  const formattedNumber = decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart

  // Return the formatted number based on the datatype
  if (datatype === "$") {
    return `$ ${formattedNumber}`
  } else if (datatype === "%") {
    return `${formattedNumber} %`
  } else {
    return formattedNumber // for both "#" and when datatype is null or undefined
  }
}
